import { useEffect } from 'react';

import { usePageConfig } from '../PageConfigProvider/PageConfigProvider';
import { usePageState } from '../PageState/PageStateProvider';
import { resolveActiveTab } from '../PageState/resolveActiveTab';

export const useGetTabs = () => {
  const { config } = usePageConfig();

  return config.tabs;
};

export const useUpdateTab = () => {
  const { dispatch: pageStateDispatch } = usePageState();

  return (tabId: string) => {
    pageStateDispatch({ type: 'SET_ACTIVE_TAB', payload: tabId });
  };
};

/** Keeps pageState.activeTabId aligned with the resolved active tab. */
export const useSyncResolvedActiveTab = () => {
  const tabs = useGetTabs();
  const { pageState, dispatch } = usePageState();

  useEffect(() => {
    const resolvedTab = resolveActiveTab(tabs, pageState.activeTabId);
    if (resolvedTab && pageState.activeTabId !== resolvedTab.id) {
      dispatch({ type: 'SET_ACTIVE_TAB', payload: resolvedTab.id });
    }
  }, [tabs, pageState.activeTabId, dispatch]);
};
